// extracted by mini-css-extract-plugin
export default {"pulse":"styles_pulse__xdK0J","animate":"styles_animate__dJvKV"};